import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { FirebaseStorage } from './core/classes/firebase-storage';

import * as Formio from 'formiojs';

@Component({
	selector: 'ngx-app',
	template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
	constructor(private recaptchaV3Service: ReCaptchaV3Service) { }

	ngOnInit(): void {
		this.loadFirebaseStorageProvider();
	}

	/**
	 * Load custom formio provider for file storage
	 */
	private loadFirebaseStorageProvider(): void {
		if (Formio)
			Formio.Providers.addProvider('storage', FirebaseStorage.title, FirebaseStorage);
	}

	/**
	 * Sends the recaptcha form info to validate the web
	 * @param form the recaptcha form
	 * @returns void
	 */
	public send(form: NgForm): void {
		if (form.invalid) {
			for (const control of Object.keys(form.controls))
				form.controls[control].markAsTouched();

			return;
		}

		this.recaptchaV3Service.execute('importantAction')
			.subscribe((token: string) => { });
	}
}